import React from "react";
import { MemberShipInputNumber } from "./membership-input-number";
import { PriceChangeSuggestion } from "../../../mvcapi/models/buyticket";

type AlreadyMemberProps = { 
    membershipTypeIDs: string[];
    addMembershipCardProcessing: boolean;
    refreshActiveMembershipCards: (membershipTypeId: string, status: any, priceChangeSuggestions: PriceChangeSuggestion[]) => void;
};

export function AlreadyMember({ membershipTypeIDs, addMembershipCardProcessing, refreshActiveMembershipCards }: AlreadyMemberProps) {
    return <div className="row">
        <MemberShipInputNumber 
            membershipTypeIDs={membershipTypeIDs}
            addMembershipCardProcessing={addMembershipCardProcessing}
            onFindMemberShipCard={refreshActiveMembershipCards}
        />
    </div>;
}